const bars = document.querySelectorAll(".progress-bar");

bars.forEach((bar) => {
  const size = bar.getAttribute('aria-valuenow');
  bar.style.width = size + '%';
})